/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:inquiryLottCartaDebitoInt
 * @restrict E
 * @description Componente per la visualizzazione di richiesta lotto
 */
(function () {
  'use strict';
  var InquiryLottCartaDebitoIntCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $filter,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    uiGridConstants,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    domainSrvc,
    inquiryLottCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.inquiryLottCtrl = this;

    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.domainSrvc = domainSrvc;
    this.inquiryLottCartaDebitoIntSrvc = inquiryLottCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Altezza della griglia carte
     */
    this.altezzaTabellaLottoCarte = 0;
    this.altezzaTabellaDettaglio = 0;
    
    /**
     * Altezza di una riga della griglia dei carte
     */
    this.altezzaRigaCarte = 30;
    
    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.inquiryLottCartaDebitoIntSrvc.spinner;

    /**
     * Inizializzazione lista lotti
     */
    this.listaLotti = null;
    
    this.lottoSelezionato = [];
    
    this.showDettaglio = false;
    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    this.cerca = function () {
    	self.spinner.showSpinner = true;
    	self.listaLotti = null;
    	self.inquiryLottCartaDebitoIntSrvc.filtro.dataDa.setHours('00');
    	self.inquiryLottCartaDebitoIntSrvc.filtro.dataDa.setMinutes('00');
    	self.inquiryLottCartaDebitoIntSrvc.filtro.dataA.setHours('23');
    	self.inquiryLottCartaDebitoIntSrvc.filtro.dataA.setMinutes('59');
          $q.all([
            self.inquiryLottCartaDebitoIntSrvc.promiseCerca(self.inquiryLottCartaDebitoIntSrvc.filtro),
          ]).then(
            function (response) {
              self.listaLotti = response[0].data.result;
              if(self.listaLotti && self.listaLotti.length>0){
            	
            	angular.forEach(self.listaLotti, function (lotto, index) {
                  lotto.prodotto = self.getDescrizioneProdotto(lotto.prodotto,  self.inquiryLottCartaDebitoIntSrvc.elencoProdotto);
                  lotto.stato = self.getDescrizioneStato(lotto.stato,  self.inquiryLottCartaDebitoIntSrvc.elencoStatiLotto);
                });
            	  self.loadElencoCarteGrid(self.listaLotti);
              }
              self.spinner.showSpinner = false;
            },
            function (reason) {
              console.error(reason);
              self.spinner.showSpinner = false;
            });
    };

    this.getDescrizioneStato = function (codice, elenco){
    	var risultato;
    	
    	angular.forEach(elenco, function (elemento, index) {
            if(elemento.codice == codice){
            	risultato = elemento.descrizione;
            }
          });
    	return risultato;
    };
    
    this.getDescrizioneProdotto = function (codice, elenco){
    	var risultato;
    	
    	angular.forEach(elenco, function (elemento, index) {
            if(elemento.codiceProdotto == codice){
            	risultato = elemento.descrizioneProdotto;
            }
          });
    	return risultato;
    };
    
    this.loadElencoCarteGrid = function (arrayCurrentCarta) {
        
    	self.altezzaTabellaLottoCarte = arrayCurrentCarta.length * self.altezzaRigaCarte + 40;

        self.lottoCarteGridOptions = {
          enableSorting: true,
          enableColumnMenus: false,
          enableGrouping: false,
          multiSelect: false,
          showHeader: true,
          enableRowHeaderSelection: false,
          enableRowSelection: false,
          showGridFooter: false,
          enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
          enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
          enableColumnResizing: true,
          columnDefs: [
            {
              displayName: $scope.msg('label.tab.inquirylott.dataInserimento'),
              field: 'dataInserimentoRichiesta',
              width: '15%',
              name: 'dataInserimentoRichiesta',
              cellFilter: 'date:\'dd-MM-yyyy\'',
              sort: {
                  direction: uiGridConstants.DESC,
                  priority: 0,
                }
            },
            {
              displayName: $scope.msg('label.tab.inquirylott.prodotto'),
              field: 'prodotto',
              width: '35%',
              name: 'prodotto'
            },
            {
              displayName: $scope.msg('label.tab.inquirylott.stato'),
              field: 'stato',
              width: '30%',
              name: 'stato'
            },
            {
                displayName: $scope.msg('label.tab.inquirylott.numero'),
                field: 'numero',
                width: '10%',
                name: 'numero'
              },
            {
              displayName: "Dettaglio",
              field: '',
              width: '10%',
              name: ' ',
              cellTemplate :'<div class="text-center"><button class="btn btn-primary"     style="padding: 2px 6px;" data-toggle="modal"  ng-click="grid.appScope.inquiryLottCtrl.apriDettaglio(row.entity)">Dettaglio</button></div>'
            }
          ],
          data: arrayCurrentCarta
        };
      };

      this.loadDettaglioGrid = function (row) {
          
      	self.altezzaTabellaDettaglio = self.altezzaRigaCarte + 40;

          self.dettaglioGridOptions = {
            enableSorting: true,
            enableColumnMenus: false,
            enableGrouping: false,
            multiSelect: false,
            showHeader: true,
            enableRowHeaderSelection: false,
            enableRowSelection: false,
            showGridFooter: false,
            enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableColumnResizing: true,
            columnDefs: [
              {
                displayName: $scope.msg('label.tab.inquirylott.utente'),
                field: 'utente',
                width: '30%',
                name: 'utente'
              },
              {
                displayName: $scope.msg('label.tab.inquirylott.posizione'),
                field: 'codicePosizioneIniziale',
                width: '30%',
                name: 'codicePosizioneIniziale'
              },
              {
                displayName: $scope.msg('label.tab.inquirylott.indirizzoSpedizione'),
                field: 'indirizzoSpedizione',
                width: '40%',
                name: 'indirizzoSpedizione'
              }
            ],
            data: row
          };
        };

      
      this.apriDettaglio = function (lotto) {
      		self.lottoSelezionato.push(lotto);
      		self.loadDettaglioGrid(self.lottoSelezionato);
      		self.showDettaglio = true;
      };
      
      this.indietro = function () {
    	  self.lottoSelezionato = [];
    		self.showDettaglio = false;
    };


    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display: none;');
      }

      var d = new Date(Date.now());
      self.inquiryLottCartaDebitoIntSrvc.filtro.dataDa = new Date(d.setMonth(d.getMonth()-1 , d.getDate()));
      
      labelSrvc.labelsPronte.then(function () {
          self.labelsPronte = true;

          // recupero delle carte per il codice prodotto
          self.spinner.showSpinner = true;
          $q.all([
            self.inquiryLottCartaDebitoIntSrvc.promiseRecuperaDominio(CONSTANTS.REST.REQ_LOTT.RECUPERA_LISTA_PRODOTTI),
            self.inquiryLottCartaDebitoIntSrvc.promiseRecuperaDominio(CONSTANTS.REST.REQ_LOTT.STATI_LOTTI)
          ]).then(
            function (response) {
              self.inquiryLottCartaDebitoIntSrvc.elencoStatiLotto = response[1].data.result;
              self.inquiryLottCartaDebitoIntSrvc.elencoStatiLottoFiltro = $filter('filter')(self.inquiryLottCartaDebitoIntSrvc.elencoStatiLotto, {visibile : "1"});
              self.inquiryLottCartaDebitoIntSrvc.elencoProdotto = response[0].data.result;
              self.spinner.showSpinner = false;
            },
            function (reason) {
              console.error(reason);
              self.spinner.showSpinner = false;
            }
          );
        });
      
    };

    self.init();
  };


  InquiryLottCartaDebitoIntCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$filter',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'uiGridConstants',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintDomainSrvc',
    'InquiryLottCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'inquiryLottCartaDebitoInt/inquiryLottCartaDebitoInt.html';
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var InquiryLottCartaDebitoIntComponent = {
    controller: InquiryLottCartaDebitoIntCtrl,
    controllerAs: 'inquiryLottCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('inquiryLottCartaDebitoInt', InquiryLottCartaDebitoIntComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/inquiryLottCartaDebitoInt/inquiryLottCartaDebitoInt.cmpt.js
// module id = 16
// module chunks = 0